import { useEffect, useState } from 'react'

import { getTranslate } from '@nx/translations'

import {
  StyledBiddingButton,
  StyledBody,
  StyledButtonContainer,
  StyledInitialBiddingButton,
} from './BiddingButton.styles'
import translate from './BiddingButton.translate.json'

const { text } = getTranslate(translate)

export const BiddingButton = ({
  label,
  onConfirmClick,
  onInitialClick,
  variant = 'compact',
  confirmationDuration = 15,
  pauseAnimation = false,
  bidValueInvalid,
  ...props
}: BiddingButtonProps) => {
  const [biddingStage, setBiddingStage] = useState<'initial' | 'confirmation'>(
    'initial'
  )

  useEffect(() => {
    setBiddingStage('initial')
  }, [label.initial])

  return (
    <StyledButtonContainer>
      {biddingStage === 'initial' ? (
        <StyledInitialBiddingButton
          {...props}
          type="button"
          variant={variant === 'compact' ? 'ghost' : 'primary'}
          onClick={() => {
            onInitialClick?.()
            setBiddingStage('confirmation')
          }}
          data-stage={biddingStage}
          disabled={bidValueInvalid}
          $variant={variant}
        >
          {label.initial}
          {bidValueInvalid ? '*' : null}
        </StyledInitialBiddingButton>
      ) : (
        <StyledBiddingButton
          {...props}
          onAnimationEnd={() => {
            setBiddingStage('initial')
          }}
          onClick={async () => {
            await onConfirmClick()
            setBiddingStage('initial')
          }}
          data-stage={biddingStage}
          disabled={bidValueInvalid}
          $animationDuration={confirmationDuration}
          $variant={variant}
          $pauseAnimation={pauseAnimation}
        >
          {label.confirmation}
        </StyledBiddingButton>
      )}

      {bidValueInvalid && (
        <StyledBody $level="XS">{text('incorrectIncrement')}</StyledBody>
      )}
    </StyledButtonContainer>
  )
}

export interface BiddingButtonProps {
  confirmationDuration?: number
  bidValueInvalid?: boolean
  label: {
    initial: string
    confirmation: string
  }
  onConfirmClick: () => Promise<void>
  onInitialClick?: () => void
  pauseAnimation?: boolean
  variant?: 'compact' | 'large'
}
